var resolveConfigObjects = require('./lib/util/resolveConfig').default;

var defaultConfig = require('./stubs/defaultConfig.stub.js');

module.exports = function resolveConfig(config) {
  return resolveConfigObjects([config, defaultConfig]);
};